<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/shopping-center/alexis_nihon.png">
            Alexis Nihon
        </client-card>
        <client-card src="img/clients-color/shopping-center/place-de-la-cite.png">
            Place de la cité
        </client-card>
        <client-card src="img/clients-color/shopping-center/galeries-rive-nord.png">
            Galeries Rive Nord
        </client-card>
        <client-card src="img/clients-color/shopping-center/carrefour-estrie.png">
            Carrefour Estrie
        </client-card>
        <client-card src="img/clients-color/retail/kim-phat.png" bg>
            Kim Phat
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `signage-shopping-mall-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Shopping Mall client guest wifi|Client centre commercial wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
